// jsonStatus values enum
export enum DepositorLockerStatus {
  full = 'full',
  empty = 'empty',
  reserved = 'reserved',
}
